import api from './api'

export default {
  // Obtener estudiantes
  getStudents() {
    return api.get('/students')
  },

  // Crear estudiante
  async createStudent(data) {
    try {
      const { data: response } = await api.post('/students', data);
      return response;
    } catch (error) {
      // Manejar error específico de RUT duplicado
      if (error.response && error.response.data && error.response.data.message === "rut must be unique") {
        throw new Error("El RUT se encuentra asignado a otro estudiante");
      }
      throw error;
    }
  },

  // Actualizar estudiante con financingPartyId y caretakerId
  async updateStudent(studentId, data) {
    try {
      const { data: response } = await api.put(`/students/${studentId}`, data);
      return response;
    } catch (error) {
      // Manejar error específico de RUT duplicado
      if (error.response && error.response.data && error.response.data.message === "rut must be unique") {
        throw new Error("El RUT se encuentra asignado a otro estudiante");
      }
      throw error;
    }
  }
} 